import React, { useEffect, useState } from 'react';
import MixerPortalHeaderBar from './Color Mixer UI Components/MixerPortalNavBar';
import MinimalFooter from '../../components/MinimalFooter';
import IcebreakerCard from './Color Mixer UI Components/IcebreakerCard';
import IcebreakerParticipantTimerHeader from './Color Mixer UI Components/IcebreakerParticipantTimerHeader';

export default function IcebreakerScreen({ prompt, partnerName, endsAt }) {
  const [countdown, setCountdown] = useState('--:--');

  useEffect(() => {
    let timer;

    const updateCountdown = () => {
      const diff = new Date(endsAt) - new Date();

      if (diff <= 0) {
        setCountdown('00:00');
        return;
      }

      const minutes = String(Math.floor(diff / 60000)).padStart(2, '0');
      const seconds = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');

      setCountdown(`${minutes}:${seconds}`);

      const delay = diff % 1000 || 1000;  // synchronize next update precisely
      timer = setTimeout(updateCountdown, delay);
    };

    updateCountdown();

    return () => clearTimeout(timer);
  }, [endsAt]);

 return (
  <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
    <div style={{ flex: 1, maxWidth: '500px', width: '100%', margin: '0 auto', textAlign: 'center' }}>
      <MixerPortalHeaderBar />
      <IcebreakerParticipantTimerHeader
        yourPic="/avatars/yourAvatar.jpg"
        partnerPic="/avatars/partnerAvatar.jpg"
        yourColour="red"
        partnerColour="blue"
        timer={countdown}
      />
      <IcebreakerCard question={prompt} />
    </div>
    <MinimalFooter />
  </div>
);
}
